// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-benchmarking {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  height: 8.3333333333vh;
  color: black;
  padding: 0 3vw 0 3vw;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  z-index: 3;
}
.navbar-benchmarking .left {
  height: 100%;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.navbar-benchmarking .left img {
  height: 85%;
  margin-right: 30px;
}
.navbar-benchmarking .left .entities-nav {
  font-size: 16px;
  font-weight: 500;
  height: 100%;
  display: flex;
  align-items: center;
}
.navbar-benchmarking .left .entities-nav .item_menu {
  height: 100%;
  cursor: pointer;
  margin-right: 40px;
  display: flex;
  align-items: center;
  width: 60px;
}
.navbar-benchmarking .left .entities-nav .item_menu:hover {
  color: var(--benchmarking-color);
}
.navbar-benchmarking .left .entities-nav .selected {
  cursor: pointer;
  margin-right: 40px;
  display: flex;
  align-items: center;
  color: var(--benchmarking-color);
  font-weight: bold;
}
.navbar-benchmarking .right {
  height: 100%;
  display: flex;
  align-items: center;
}
.navbar-benchmarking .right .search {
  display: flex;
  align-items: center;
  width: 400px;
  height: 35px;
  border-radius: 10px;
  border: 1px solid var(--light-grey);
  padding: 3px;
}
.navbar-benchmarking .right .search .search-bar {
  border-right: 1px solid var(--light-grey);
  width: 80%;
}
.navbar-benchmarking .right .search .search-bar .input-search {
  width: 100%;
  font-size: 14px;
  height: 95%;
  padding: 5px;
  border: none;
  border-radius: 10px;
  outline: none;
}
.navbar-benchmarking .right .search .input-search:hover {
  background: var(--background-nav-hover);
}
.navbar-benchmarking .right .search .input-search:focus {
  background: white;
}
.navbar-benchmarking .ant-select {
  width: 100%;
}
.navbar-benchmarking .ant-select-selector {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Benchmarking/Scss/Navbar.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,UAAA;AACF;AAAE;EACE,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAEJ;AADI;EACE,WAAA;EACA,kBAAA;AAGN;AADI;EACE,eAAA;EACA,gBAAA;EAEA,YAAA;EACA,aAAA;EACA,mBAAA;AAGN;AAFM;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAIR;AAFM;EACE,gCAAA;AAIR;AADM;EACE,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EAEA,gCAAA;EACA,iBAAA;AAGR;AAEE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAAJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,mCAAA;EACA,YAAA;AACN;AAAM;EACE,yCAAA;EACA,UAAA;AAER;AADQ;EACE,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;AAGV;AAAM;EACE,uCAAA;AAER;AAAM;EACE,iBAAA;AAER;AAEE;EACE,WAAA;AAAJ;AAEE;EACE,YAAA;AAAJ","sourcesContent":[".navbar-benchmarking {\n  position: fixed;\n  top: 0;\n  right: 0;\n  width: 100%;\n  height: calc(100vh / 12);\n  color: black;\n  padding: 0 3vw 0 3vw;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: white;\n  z-index: 3;\n  .left {\n    height: 100%;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    img {\n      height: 85%;\n      margin-right: 30px;\n    }\n    .entities-nav {\n      font-size: 16px;\n      font-weight: 500;\n      display: flex;\n      height: 100%;\n      display: flex;\n      align-items: center;\n      .item_menu {\n        height: 100%;\n        cursor: pointer;\n        margin-right: 40px;\n        display: flex;\n        align-items: center;\n        width: 60px;\n      }\n      .item_menu:hover {\n        color: var(--benchmarking-color);\n        // border-bottom: 3px solid var(--benchmarking-color);\n      }\n      .selected {\n        cursor: pointer;\n        margin-right: 40px;\n        display: flex;\n        align-items: center;\n        font-weight: bold;\n        color: var(--benchmarking-color);\n        font-weight: bold;\n        // border-bottom: 3px solid var(--benchmarking-color);\n      }\n    }\n  }\n  .right {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    .search {\n      display: flex;\n      align-items: center;\n      width: 400px;\n      height: 35px;\n      border-radius: 10px;\n      border: 1px solid var(--light-grey);\n      padding: 3px;\n      .search-bar {\n        border-right: 1px solid var(--light-grey);\n        width: 80%;\n        .input-search {\n          width: 100%;\n          font-size: 14px;\n          height: 95%;\n          padding: 5px;\n          border: none;\n          border-radius: 10px;\n          outline: none;\n        }\n      }\n      .input-search:hover {\n        background: var(--background-nav-hover);\n      }\n      .input-search:focus {\n        background: white;\n      }\n    }\n  }\n  .ant-select {\n    width: 100%;\n  }\n  .ant-select-selector {\n    height: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
